import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { IPaymentBreakdownItemGroup } from '@interfaces/payment-breakdown-group';
import { filterFeeItems } from '@app/shared/helpers';

@Component({
  selector: 'card-payment',
  templateUrl: './card-payment.component.html',
  styleUrls: ['./card-payment.component.scss'],
})
export class CardPaymentComponent implements OnInit, OnChanges {
  @Input() public referenceNumber: string = '';
  @Input() public header: string = 'LABELS.PAYMENT_BREAKDOWN';
  @Input() public hint: string = 'PAYMENT_BREAKDOWN.HINT';
  @Input() public paymentTotalHeader: string = 'LABELS.TOTAL_PAYMENT';
  @Input() public footer: string;
  @Input() public paymentGroupItems: IPaymentBreakdownItemGroup[] = [];
  @Input() public isShowCreditCardsHint: boolean = false;
  @Input() public isLateEntry?: boolean;

  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;

  constructor() {}

  public ngOnInit(): void {
    this.filterItems();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.paymentGroupItems) {
      this.filterItems();
    }
  }

  public filterItems(): void {
    filterFeeItems(this.paymentGroupItems);
  }

  public get paymentTotalPrice(): number {
    return this.paymentGroupItems
      .reduce((paymentItems, paymentGroupItems) => [...paymentItems, ...paymentGroupItems.items], [])
      .filter((paymentItem) => paymentItem.priceType !== 'canceled')
      .filter((paymentItem) => paymentItem.type === 'price')
      .reduce((prevValue, currItem) => prevValue + currItem.quantity * currItem.price, 0);
  }
}
